import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useFormik } from "formik";
import { useContext, useEffect, useState } from "react";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import AutoComplete, { AutoCompleteOption } from "../common/AutoComplete";
import { nameof } from "../common/ObjectUtils";
import MonySymbolsComponets from "../common/MonySymbolsComponents";
import { getAllClass, getAllPart, getAllWinityCodes } from "./ManipulateValues";
import DamageService from "./service/damage.action";
import { DamageTypes } from "./Types";
import * as Yup from "yup";
import "./damagePrice.css";
import { ContextOperation } from "../../context/OperationContext";
interface Props {
  open: boolean;
  onClose: () => void;
  updateDatasourceDamage: () => void;
  onReset: () => void;
  formikValues: DamageTypes.FilterDamage;
}

const CreateDamagePriceList = (props: Props) => {
  const [listCarClass, setListCarClass] = useState<AutoCompleteOption[]>([]);
  const [listPart, setListPart] = useState<AutoCompleteOption[]>([]);
  const [winityCode, setWinityCode] = useState<AutoCompleteOption[]>([]);

  const { setLoading } = useContext(ContextOperation);
  const snackbar = useSnackbar();
  const t = useOperationTranslation();
  const { tenant } = useContext(ContextOperation);
  const paintExtraTime = [
    {
      value: true,
      label: t("internOptionSelectName.true"),
    },
    {
      value: false,
      label: t("internOptionSelectName.false"),
    },
  ];

  useEffect(() => {
    getAllClass(tenant).then((response) => {
      setListCarClass(response);
    });
    getAllPart(tenant).then((response) => {
      setListPart(response);
    });
    getAllWinityCodes(tenant).then((response: any) => {
      setWinityCode(response);
    });
  }, []);

  const handleSubmit = (data: DamageTypes.Create) => {
    console.log(JSON.stringify(data));

    if (data.substitionPrice) {
      data.substitionPrice = data.substitionPrice * 100;
    }
    if (data.lightPrice) {
      data.lightPrice = data.lightPrice * 100;
    }
    if (data.mediumPrice) {
      data.mediumPrice = data.mediumPrice * 100;
    }
    if (data.heavyPrice) {
      data.heavyPrice = data.heavyPrice * 100;
    }

    setLoading(true);
    DamageService.create.createDamage(data, tenant).then(
      () => {
        onClose();
        if (props.formikValues) {
          props.onReset();
        }
        setLoading(false);
        snackbar.show("success", t("dangerPrice.messages.successMessages"));
      },
      (error: any) => {
        // onClose();

        if (data.substitionPrice) {
          data.substitionPrice = data.substitionPrice / 100;
        }
        if (data.lightPrice) {
          data.lightPrice = data.lightPrice / 100;
        }
        if (data.mediumPrice) {
          data.mediumPrice = data.mediumPrice / 100;
        }
        if (data.heavyPrice) {
          data.heavyPrice = data.heavyPrice / 100;
        }

        setLoading(false);
        if (error.response.status == 406) {
          snackbar.show("error", t("dangerPrice.messages.create406Error"));
        } else if (error.response.status == 404) {
          snackbar.show("error", t("dangerPrice.messages.create404Error"));
        } else if (error.response.status == 400) {
          snackbar.show("error", t("dangerPrice.messages.create400Error"));
        } else snackbar.show("error", t("dangerPrice.messages.create500Error"));
      }
    );
    props.onReset();
  };

  let validateForm = {
    carClass: Yup.string().required(),
    part: Yup.string().required(),
    substitionPrice: Yup.number().required(),
    lightPrice: Yup.number().required(),
    mediumPrice: Yup.number().required(),
    heavyPrice: Yup.number().required(),
    paintExtraTime: Yup.string().required(),
    winityCodeVehicle: Yup.number(),
    winityCodeIndustrial: Yup.number(),
    figureCode: Yup.number(),
  };
  const ValidateForm = Yup.object().shape(validateForm);
  const formik = useFormik<any>({
    initialValues: {},
    //validationSchema: ValidateForm, NOTA: non funziona la gestione degli errori, così non è utile
    onSubmit: handleSubmit,
  });
  const onClose = () => {
    props.onClose();
    formik.resetForm();
  };

  return (
    <Mui.Card style={{ margin: "12px" }}>
      <>
        <Mui.Grid container alignItems="center">
          <Mui.Grid item xs="auto">
            <Mui.Typography
              variant="h6"
              pl={2}
              pt={2}
              style={{ opacity: "0.6", color: "#18305B" }}
            >
              {t("dangerPrice.dialogs.create.title")}
            </Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>
      </>
      <form
        id="form-create-equipment-kit-association"
        onSubmit={formik.handleSubmit}
      >
        <Mui.Grid container spacing="16px" p={2}>
          <Mui.Grid item md={3} xs={12}>
            <AutoComplete
              options={listCarClass}
              label={t("dangerPrice.fields.carClass")}
              value={formik.values.carClass || ""}
              onChange={(value) => {
                formik.setFieldValue(
                  nameof<DamageTypes.FilterDamage>("carClass"),
                  value
                );
              }}
              fullWidth
            />
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <AutoComplete
              // sx={{color:"red"}}
              options={listPart}
              label={t("dangerPrice.fields.part")}
              onChange={(value) =>
                formik.setFieldValue(nameof<DamageTypes.Damage>("part"), value)
              }
              value={formik.values.part || ""}
              fullWidth
            />
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <Mui.TextField
              label={t("dangerPrice.fields.substitution")}
              name={nameof<DamageTypes.Edit>("substitionPrice")}
              fullWidth
              onChange={formik.handleChange}
              value={formik.values.substitionPrice}
              InputProps={{
                startAdornment: formik.values.substitionPrice ? (
                  <Mui.InputAdornment position="start">
                    <MonySymbolsComponets symbols="EUR" />
                  </Mui.InputAdornment>
                ) : (
                  ""
                ),
              }}
            />
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <Mui.TextField
              label={t("dangerPrice.fields.damage")}
              name={nameof<DamageTypes.Edit>("lightPrice")}
              fullWidth
              value={formik.values.lightPrice || ""}
              onChange={formik.handleChange}
              InputProps={{
                startAdornment: formik.values.lightPrice ? (
                  <Mui.InputAdornment position="start">
                    <MonySymbolsComponets symbols="EUR" />
                  </Mui.InputAdornment>
                ) : (
                  ""
                ),
              }}
            />
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid container spacing="16px" p={2}>
          <Mui.Grid item md={3} xs={12}>
            <Mui.TextField
              label={t("dangerPrice.fields.medium")}
              name={nameof<DamageTypes.Edit>("mediumPrice")}
              fullWidth
              value={formik.values.mediumPrice || ""}
              onChange={formik.handleChange}
              InputProps={{
                startAdornment: formik.values.mediumPrice ? (
                  <Mui.InputAdornment position="start">
                    <MonySymbolsComponets symbols="EUR" />
                  </Mui.InputAdornment>
                ) : (
                  ""
                ),
              }}
            />
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <Mui.Grid item>
              <Mui.TextField
                label={t("dangerPrice.fields.heavy")}
                name={nameof<DamageTypes.Edit>("heavyPrice")}
                fullWidth
                value={formik.values.heavyPrice || ""}
                onChange={formik.handleChange}
                InputProps={{
                  startAdornment: formik.values.heavyPrice ? (
                    <Mui.InputAdornment position="start">
                      <MonySymbolsComponets symbols="EUR" />
                    </Mui.InputAdornment>
                  ) : (
                    ""
                  ),
                }}
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <Mui.FormControl variant="standard" fullWidth>
              <Mui.InputLabel>{t("dangerPrice.fields.paint")}</Mui.InputLabel>
              <Mui.Select
                label={t("dangerPrice.fields.paint")}
                fullWidth
                name={nameof<DamageTypes.Edit>("paintExtraTime")}
                value={formik.values.paintExtraTime}
                onChange={formik.handleChange}
              >
                {paintExtraTime.map((el: any, index: number) => (
                  <Mui.MenuItem key={index} value={el.value}>
                    {el.label}
                  </Mui.MenuItem>
                ))}
              </Mui.Select>
            </Mui.FormControl>
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <Mui.TextField
              label={t("dangerPrice.fields.winity")}
              name={nameof<DamageTypes.Edit>("winityCodeVehicle")}
              fullWidth
              value={formik.values.winityCodeVehicle || ""}
              style={{
                color:
                  formik.values.winityCodeVehicle == "" ? "#18305B" : "red",
                fontWeight: "500",
              }}
              onChange={formik.handleChange}
            />
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid container spacing="16px" p={2}>
          <Mui.Grid item md={3} xs={12}>
            <Mui.Grid item>
              <Mui.TextField
                label={t("dangerPrice.fields.industrial")}
                name={nameof<DamageTypes.Edit>("winityCodeIndustrial")}
                fullWidth
                value={formik.values.winityCodeIndustrial || ""}
                onChange={formik.handleChange}
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <Mui.Grid item>
              <Mui.TextField
                label={t("dangerPrice.fields.figure")}
                name={nameof<DamageTypes.Edit>("figureCode")}
                fullWidth
                value={formik.values.figureCode || ""}
                onChange={formik.handleChange}
              />
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      </form>

      <>
        <Mui.Grid container justifyContent="end" spacing="16px" p={2}>
          <Mui.Grid item xs="auto">
            <Mui.Button variant="outlined" size="medium" onClick={onClose}>
              {t(
                "vehicleEquipmentAssociation.dialogs.editAcriss.actions.cancel"
              )}
            </Mui.Button>
          </Mui.Grid>
          <Mui.Grid item xs="auto">
            <Mui.Button type="submit" size="medium" onClick={formik.submitForm}>
              {t("dangerPrice.dialogs.create.saveButton")}
            </Mui.Button>
          </Mui.Grid>
        </Mui.Grid>
      </>
    </Mui.Card>
  );
};

export default CreateDamagePriceList;
